/**
 * Calculate optimal load count based on viewport dimensions
 */
function calculateOptimalLoadCount(): number {
  const viewport = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  // Estimate grid columns based on breakpoints (similar to typical responsive grids)
  let columns: number;
  if (viewport.width < 640) {
    columns = 2; // mobile
  } else if (viewport.width < 768) {
    columns = 3; // small tablet
  } else if (viewport.width < 1024) {
    columns = 4; // tablet
  } else if (viewport.width < 1280) {
    columns = 5; // small desktop
  } else {
    columns = 6; // large desktop
  }

  const estimatedCardWidth = viewport.width / columns;
  // Some buffer
  const estimatedCardHeight = estimatedCardWidth * 1.2;

  // Calculate how many rows fit in the viewport (with buffer)
  const availableHeight = viewport.height * 0.8;
  const rowsNeeded = Math.ceil(availableHeight / estimatedCardHeight);

  // Add extra rows to ensure we overfill slightly for better UX
  const bufferRows = 2;
  const totalRows = rowsNeeded + bufferRows;

  const calculatedCount = totalRows * columns;

  const minCount = 12;
  const maxCount = 50;
  return Math.max(minCount, Math.min(maxCount, calculatedCount));
}

export { calculateOptimalLoadCount };
